var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('uiv-btn',{staticClass:"tb__refresh-button",style:(_vm.btnStyle),on:{"click":function($event){$event.stopPropagation();return _vm.refresh($event)}}},[_c('i',{staticClass:"glyphicon glyphicon-refresh"}),_vm._v("Refresh ")])}
var staticRenderFns = []

export { render, staticRenderFns }